import { Entity, IEntity } from '@lycoris-nubila/ngx-lycoris';
import { Observable, of } from 'rxjs';

import { ModuleQuestionFieldType } from 'module/page/question/model/field/module-question-field.type';

import {
	IModuleQuestionFieldI18n,
	ModuleQuestionFieldI18n,
} from './module-question-field-i18n';

export interface IModuleQuestionField extends IEntity {
	readonly name: string;
	readonly value: string;
	readonly position: number;
	readonly minLines: number;
	readonly condition: string;
	readonly gridClass: string;
	readonly isRequired: boolean;
	readonly isExtraField: boolean;
	readonly optionsGroup: string;
	readonly optionsScript: string;
	readonly optionsGridClass: string;
	readonly type: ModuleQuestionFieldType;
	readonly localizations: ReadonlyArray<IModuleQuestionFieldI18n>;
	readonly localization$: Observable<IModuleQuestionFieldI18n>;
}

export class ModuleQuestionField
	extends Entity
	implements IModuleQuestionField
{
	constructor(
		id: string,
		name: string,
		value: string,
		position: number,
		minLines: number,
		condition: string,
		gridClass: string,
		isRequired: boolean,
		isExtraField: boolean,
		optionsGroup: string,
		optionsScript: string,
		updateTimestamp: number,
		optionsGridClass: string,
		type: ModuleQuestionFieldType,
		localizations: ModuleQuestionFieldI18n[],
		localization$: Observable<ModuleQuestionFieldI18n> = of(null)
	) {
		super(id, null, updateTimestamp);
		this._name = name;
		this._value = value;
		this._type = type;
		this._position = position;
		this._minLines = minLines;
		this._condition = condition;
		this._gridClass = gridClass;
		this._isRequired = isRequired;
		this._isExtraField = isExtraField;
		this._optionsGroup = optionsGroup;
		this._optionsScript = optionsScript;
		this._optionsGridClass = optionsGridClass;
		this._localizations = localizations || [];
		this._localization$ = localization$;
	}

	private _name: string;

	public get name(): string {
		return this._name;
	}

	private _value: string;

	public get value(): string {
		return this._value;
	}

	private _position: number;

	public get position(): number {
		return this._position;
	}

	private _minLines: number;

	public get minLines(): number {
		return this._minLines;
	}

	private _condition: string;

	public get condition(): string {
		return this._condition;
	}

	private _gridClass: string;

	public get gridClass(): string {
		return this._gridClass;
	}

	private _isRequired: boolean;

	public get isRequired(): boolean {
		return this._isRequired;
	}

	private _isExtraField: boolean;

	public get isExtraField(): boolean {
		return this._isExtraField;
	}

	private _optionsGroup: string;

	public get optionsGroup(): string {
		return this._optionsGroup;
	}

	private _optionsScript: string;

	public get optionsScript(): string {
		return this._optionsScript;
	}

	private _optionsGridClass: string;

	public get optionsGridClass(): string {
		return this._optionsGridClass;
	}

	private _type: ModuleQuestionFieldType;

	public get type(): ModuleQuestionFieldType {
		return this._type;
	}

	private _localizations: ModuleQuestionFieldI18n[];

	public get localizations(): ModuleQuestionFieldI18n[] {
		return this._localizations;
	}

	private _localization$: Observable<ModuleQuestionFieldI18n>;

	public get localization$(): Observable<ModuleQuestionFieldI18n> {
		return this._localization$;
	}
}
